import Splide from '@splidejs/splide';

const EL = '.js-mentions-carousel';

document.querySelectorAll(EL).forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 170,
    fixedWidth: '930px',
    breakpoints: {
      1024: {
        fixedWidth: '680px',
        gap: 60,
      },
      767: {
        gap: 30,
        fixedWidth: '100%',
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }
});
